import React from "react";
import LongTermUploadContent from "./LongTermUploadContent";

function LongTermUploadModal(props: any) {
  return (
    <LongTermUploadContent
      isOpen={props.isOpen}
      onClose={props.onClose}
      selectedFolderId={props.selectedFolderId}
      selectedScenarioId={props.selectedScenarioId}
      handleGoBack={props.handleGoBack}
      selectRadio={props.selectRadio}
      embedded={false}
      showCrossMark={props.showCrossMark}
    />
  );
}

export default LongTermUploadModal;
